define('login',['durandal/system', 'plugins/router', 'durandal/app', 'jquery', 'utils'], function (system, router, app) {
    var viewmodel = function() {
        var self = this;
        self.app = app;
        self.activate = function () {
            router.map([
                {
                    route: '',
                    title: 'Log In',
                    moduleId: 'auth/auth'
                },
                {
                    route: 'authentication/email',
                    title: 'mapForge Login',
                    moduleId: 'auth/email'
                },
                {
                    route: 'authentication*path',
                    title: 'Authentication Redirect',
                    moduleId: 'auth/redirect'
                }
            ])
                .buildNavigationModel()
                .mapUnknownRoutes(function (instruction) {
                    window.location.href = '/?returnUrl=/' + instruction.fragment;
                });
            
            return router.activate({ pushState: true });
        };
    };

    return viewmodel;
});

